/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateWebListingPaymentRequest} from '@cash-web/protos/squareup/cash/cashbusinesspayments/api/v1beta1/listing.pb'
import {CreateWebListingPaymentResponse} from '@cash-web/protos/squareup/cash/cashbusinesspayments/api/v1beta1/listing.pb'


export const createWebListingPayment = (request: CreateWebListingPaymentRequest, options?: CashRequestOptions) => post<CreateWebListingPaymentRequest, CreateWebListingPaymentResponse>("/cash-app/business-payments/create-web-listing-payment", request, {...options, rejectOnError: true })